'use client';

import { usePathname } from 'next/navigation';
import AppLayout from '@/components/AppLayout';
import { DialogProvider } from '@/components/dialog/DialogProvider';
import MsalProvider from '@/components/MsalProvider';
import { UserScopedFilterPersistInitializer } from '@/components/initializers/UserScopedFilterPersistInitializer';

/**
 * Wraps the interactive app shell in MSAL when the route is not the MSAL Browser v5 redirect bridge.
 * The bridge page (`/redirect`) must not use `MsalProvider` so the OAuth response is handled only by
 * `broadcastResponseToMainFrame` before `PublicClientApplication` runs (`app/redirect/page.tsx`).
 */
export default function MsalAuthenticatedShell({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const isMsalRedirectBridge = pathname === '/redirect' || pathname.endsWith('/redirect');

  if (isMsalRedirectBridge) {
    return <>{children}</>;
  }

  return (
    <MsalProvider>
      <UserScopedFilterPersistInitializer />
      <AppLayout>
        <DialogProvider>{children}</DialogProvider>
      </AppLayout>
    </MsalProvider>
  );
}
